<template>
  <div class="d-flex">
    <div>
      <account-icon :type="account.type" />
    </div>
    <div class="ml-2 w-100">
      <span class="d-inline">{{ account.description }}</span>
      <template v-if="account.type == 'd'">
        <small class="text-info ml-1">
          ({{ getDrawerText(account.active_shift) }})
        </small>
      </template>
      <br />
      <small class="text-muted">
        {{ accountTypes[account.type].typeDescription }}
      </small>
      <br />
      <template v-if="account.type == 'b'">
        <small class="text-muted">{{ account.bank }} | </small>
        <small class="text-muted" v-if="account.bank_agency">
          Agência: {{ account.bank_agency }}</small
        >
        <small class="text-muted" v-if="account.bank_account">
          Conta: {{ account.bank_account }}</small
        >
      </template>
    </div>
  </div>
</template>

<script>

import AccountTypes from "@/mixins/account/AccountTypes"
import Drawer from "@/mixins/account/Drawer"
import AccountIcon from "@/components/account/sections/AccountIcon.vue";

export default {
  components: { AccountIcon },
  
  mixins : [ AccountTypes, Drawer ],

  props: {
    account: {},
  },
  
};
</script>

<style>
</style>